import * as React from 'react';
import { Link } from 'react-router-dom';
import { SingleItem } from './singleItem';
import { Scrollbars } from 'react-touch-scrollbars';

export const ListComponent = ({ items }: any) => {
  return (
    
    <div className="container-fluid list">
      <Scrollbars style={{ height: 'calc(100vh - 280px)' }}>
      <div className='row'>
        {items && items.map((item) => (<Link to={"/product/" + item.sectionProductId} className='col'><SingleItem item={item} /></Link>))}
      </div>
      </Scrollbars>
    </div>
  )
}
